import { useSelect } from "@chakra-ui/react";
import { notify } from "common/toastUtil";
import { validateAddAPP } from "common/validation";
import { validateAddAdmin } from "common/validation";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppList } from "services/userService";
import { getAppListThunk } from "slices/userSlice";
import { getActiveGateWayListThunk } from "slices/userSlice";
import { updateAppThunk } from "slices/userSlice";
import { addAppRegisterThunk } from "slices/userSlice";
import { fetchAdminThunk } from "slices/userSlice";
import { resetSubmission } from "slices/userSlice";
import { addAppAdminOrAgentThunk } from "slices/userSlice";

export default function AddAppModal({open, setOpen, singleData,setSingleData}) {

  const [form, setForm] = React.useState({
    app_name: "",
    app_id: "",
    app_url: "",
    payment_method: "",
    gateway_id:""
  });
    const [errors, setErrors] = useState({
   app_name: "",
    app_id: "",
    app_url: "",
    payment_method: "",
    });
const dispatch = useDispatch();
const {data,error,status,activeGatewayList,uniqueCode}=useSelector((state) => state.users);

const handleChange = (e) => {
  const { name, value } = e.target;
  const updated = { ...form, [name]: value };

  // If selecting gateway_id, also update payment_method name
  if (name === "gateway_id") {
    const selectedGateway = activeGatewayList.find((item) => item._id === value);
    updated.payment_method = selectedGateway?.gateway_name || "";
  }

  setForm(updated);

  const fieldError = validateAddAPP(updated);
  setErrors((prev) => ({
    ...prev,
    [name]: fieldError[name] ?? ""
  }));
};




  const handleSubmit = () => {
    const validationErrors = validateAddAPP(form);
     setErrors(validationErrors);
    const isValid = Object.values(validationErrors).every((x) => x === "")
    if (isValid) {
      if(singleData?._id){
dispatch(updateAppThunk({
  ...form,
  id:singleData?._id
}))
      }else{
     dispatch(addAppRegisterThunk(form))

      }
    }
  };

    useEffect(() => {
      dispatch(getActiveGateWayListThunk())
        if (singleData) {
        setForm({
            app_name: singleData.app_name || "",
            app_id: singleData.app_id || "",
            app_url: singleData.app_url || "",
            payment_method: singleData.payment_method || "",
            type:"Edit"
        });
        }
    }, [singleData]);
useEffect(() => {
  if (data?.status === 201 && uniqueCode === "A12") {
    setOpen(false);
    notify("success", data.message);
    setForm({ app_name: "", app_id: "", app_url: "", payment_method: "" });
    setErrors({ app_name: "", app_id: "", app_url: "", payment_method: "" });
    dispatch(resetSubmission());
    dispatch(getAppListThunk());
  } else if ((data?.status && data.status !== 200 && data.status !== 201) || error) {
    // Only trigger error notification for truly "other" statuses
    if (error) notify("error", error);
  }
}, [data?.status, uniqueCode, error]);
  return (
    <>
  

      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 bg-[#0d0d0c99] "
          aria-modal="true"
          role="dialog"
        >
          <div className="bg-white dark:bg-navy-700 rounded-xl w-full max-w-md mx-4 p-6">
            <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
             {form?.type==="Edit" ? "Edit App" :"Register New App"}
            </h2>
            {/* Email */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                App Name*
              </label>
              <input
                name="app_name"
                type="app_name"
                value={form.app_name}
                placeholder="Enter app name"
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.app_name && (
                <p className="text-red-500 text-sm mt-1">{errors.app_name}</p>)
              }
            </div>
            {/* Password */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                App Id*
              </label>
              <input
                name="app_id"
                type="text"
                  placeholder="Enter app id"
                value={form.app_id}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.app_id && (
                <p className="text-red-500 text-sm mt-1">{errors.app_id}</p>)
              }
            </div>
            {/* Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                App URL*
              </label>
              <input
                name="app_url"
                type="text"
                  placeholder="Enter app URL"
                value={form.app_url}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.app_url && (
                <p className="text-red-500 text-sm mt-1">{errors.app_url}</p>)
              }
            </div>
            {/* Role */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Payment Method*
              </label>
 <select
  name="gateway_id"
  value={form.gateway_id || ""}
  onChange={handleChange}
  className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
>
  <option value="">Select Payment Method</option>
  {activeGatewayList?.map((method) => (
    <option key={method._id} value={method._id}>
      {method.gateway_name} — {method.mode}
    </option>
  ))}
</select>

                 {
                errors.payment_method && (
                <p className="text-red-500 text-sm mt-1">{errors.payment_method}</p>)
              }
            </div>
           
            <div className="flex justify-end space-x-3">
              <button
                onClick={() =>{
                    setOpen(false);
                    setForm({
                        app_name: "",
                        app_id: "",
                        app_url: "",
                        payment_method: "",
                    });
                    setErrors({
                        app_name: "",
                        app_id: "",
                        app_url: "",
                        payment_method: "",
                    });
                    setSingleData({})
                }}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-600 rounded hover:bg-gray-300 dark:hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
